module.exports = __webpack_public_path__ + "static/media/5.7006bacb.mp4";